import { useEffect } from 'react'
import { FormControl, Grid, TextField } from '@mui/material'

import {
    CustomAutocomplete,
    LinearLoading
} from '../../../../../../../common'

import { SlipSection } from './SlipSection'

export const TransferToBank = ({ useFetchInit, readOnlyMode }) => {

    const {
        Forms,
        FetchData
    } = useFetchInit

    const { fetchBanksByCurrency } = FetchData
    const { dataBanksByCurrency, loadingFetchBanksByCurrency } = fetchBanksByCurrency

    const { FormScreen } = Forms
    const { formState, onInputChange, onInputNumberChange, onSelectSearchChange } = FormScreen

    useEffect(() => {
                    
        fetchBanksByCurrency.setParamsToSearch({
            currency_type: formState.currency_type // Según el tipo de moneda seleccionado (solo puede transferir a los mismos tipos)
        })
        fetchBanksByCurrency.executeFetch()

    }, [formState.currency_type])

    return (
        <>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="monto_solicitado"> * Monto a Trasladar</label>
                        <TextField
                            id='monto_solicitado'
                            name='monto_solicitado'
                            value={ formState.monto_solicitado_mask } 
                            onChange={ onInputNumberChange }
                            size='small'
                            placeholder='500.50, 100.00'
                            type='text'
                            variant={readOnlyMode? 'filled': 'outlined'}
                            hiddenLabel
                            InputProps={{
                                readOnly: readOnlyMode 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="idbanco">* Banco Destino</label>
                        {(loadingFetchBanksByCurrency)&&(<LinearLoading/>)}
                        <CustomAutocomplete 
                            customId="idbanco"
                            customName="idbanco"
                            customValue={formState.idbanco}
                            customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idbanco', value: value.value }})}
                            customPlaceholder='Seleccionar opción'
                            customOptions={
                                dataBanksByCurrency.map(({ idbanco, nombre, currency_type }) => ({
                                    value: idbanco,
                                    name: `${nombre} - ${currency_type}`
                                }))
                            }
                            customDisableClearable={true}
                            customDisabled={readOnlyMode}
                        />
                    </FormControl>
                </Grid>
            </Grid>

            {(['Traslado Aprobado', 'Revisión de Depósito'].includes(formState.aprobacion_check))&&(
                <SlipSection useFetchInit={useFetchInit} readOnlyMode={readOnlyMode}/>
            )}
                        
        </>
    )
}
